import "./assets/css/index.css";
import "./assets/css/common.css";
import "./assets/css/spacing.css";
import "./assets/css/fonts.css";
import "./assets/css/text.css";
// import i18n (needs to be bundled ;))
import "./i18n";

import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error('Missing root element "#root"');
}
const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
